// Android shells on a never-updated system WebView (Chrome 90 seen in prod) lack
// `.at()` (Chrome 92), and fbtee calls `String.prototype.at` on every string
// param substitution — without this, any `fbt.param` render crashes the route.
export function at<T>(this: ArrayLike<T>, index: number): T | undefined {
  const n = Math.trunc(index) || 0
  const i = n < 0 ? this.length + n : n
  return i < 0 || i >= this.length ? undefined : this[i]
}

function install(proto: object) {
  if (!('at' in proto)) {
    Object.defineProperty(proto, 'at', { value: at, writable: true, configurable: true })
  }
}

install(Array.prototype)
install(String.prototype)
